import { render, staticRenderFns } from "./PeriodicChecksStatus.vue?vue&type=template&id=66524fe5&scoped=true"
import script from "./PeriodicChecksStatus.vue?vue&type=script&lang=js"
export * from "./PeriodicChecksStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66524fe5",
  null
  
)

export default component.exports